import React from "react";
import { object, oneOf } from "prop-types";
import classNames from "classnames/bind";
import { RichText } from "../../sharedComponents/RichText";
import * as styles from "./Label.module.scss";
// eslint-disable-next-line import/no-cycle
import { Link } from "../Link/Link";

const cx = classNames.bind(styles);

const Label = ({ content, variant }) => (
	<RichText data={content} className={cx(variant)} LinkRenderComponent={Link} />
);

Label.propTypes = {
	content: object.isRequired,
	variant: oneOf(["weddingPriceTag"]).isRequired,
};

export default Label;
export { Label };
